module.exports = __webpack_public_path__ + "fonts/iconfont.ee88d0ee.ttf";